// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"896":"3526c888","1896":"3526c888","3127":"3526c888","3911":"3526c888","5396":"3526c888","6230":"3526c888","8341":"3526c888"}[chunkId] + ".chunk.css";
};